import React from 'react';
export function TrustBar() {
  const trustItems = ['Free Commercial Estimates', 'Storefront Glass Specialists', 'Office Glass Walls & Dividers', 'Contract Glazing Available', 'Fabrication & Installation', 'Repair & Replacement', 'Service & Maintenance', 'Howell, Ann Arbor & Novi'];
  return <div className="bg-white border-y border-neutral-200 py-4" data-id="element-787">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-788">
        <div className="flex flex-wrap justify-center gap-2 md:gap-3" data-id="element-789">
          {trustItems.map((item, idx) => <div key={idx} className="flex items-center gap-2 text-neutral-700 text-xs sm:text-sm font-medium px-3 py-1.5 whitespace-nowrap font-sans anim-fade-up" style={{
          animationDelay: `${idx * 0.05}s`
        }} data-id="element-790">
              <div className="w-1.5 h-1.5 rounded-full bg-primary-600" data-id="element-791"></div>
              {item}
            </div>)}
        </div>
      </div>
    </div>;
}